// Set while support staff are signed in as a customer through WorkOS impersonation. It lives
// outside AuthService so that MixpanelService, which AuthService depends on, can read it too.
const IMPERSONATOR_KEY = 'workos_impersonator';

/** The email of the support person impersonating this session's user, or null for an ordinary session. */
export function storedImpersonator(): string | null {
  return localStorage.getItem(IMPERSONATOR_KEY);
}

export function storeImpersonator(email: string | null): void {
  if (email) {
    localStorage.setItem(IMPERSONATOR_KEY, email);
  } else {
    localStorage.removeItem(IMPERSONATOR_KEY);
  }
}
